import HeaderBlack from '../../components/header/headerBlack/headerBlack'
import StatusCard from '../../components/statusCard/statusCard'
import styles from './ajouterPatient.module.css'
import React,{ useState,useEffect, useRef } from 'react'
import {collection, addDoc, getDoc, updateDoc, onSnapshot, serverTimestamp, getDocs, query, where } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { auth,db,storage} from '../../firebase/firebase'
import choisir from '../../assets/icons/choisir.png'
import detail from '../../assets/icons/detail.png';
import radio from '../../assets/icons/radio.png';
import scan from '../../assets/icons/scan.png';
import prescription from '../../assets/icons/prescription.png';
import review from '../../assets/icons/review.png';
import line from '../../assets/icons/Line.png';

import choisir3 from "../../assets/icons/Choisir un produit -3.png"
import detail3 from "../../assets/icons/Détails du patient-3.png"
import photoRadiographie from '../../assets/icons/Photos_Radiographie-3.png';
import scan3 from "../../assets/icons/Scan -3.png"
import adult from "../../assets/img/adult.png"
import adol from "../../assets/img/adol.png"
import enfant from "../../assets/img/enfants.png"




import p1 from '../../assets/img/profile.png';
import p2 from '../../assets/img/front no smiling.png';
import p3 from '../../assets/img/front smiling.png';

import h1 from '../../assets/img/man profile.png'
import h2 from '../../assets/img/man front no smiling.png';
import h3 from '../../assets/img/man font smiling.png';

import p4 from '../../assets/img/Upper.png';
import icone from '../../assets/img/icone.png';
import p5 from '../../assets/img/Lower.png';
import p6 from '../../assets/img/right side.png';
import p7 from '../../assets/img/front teeth.png';
import p8 from '../../assets/img/left side.png';
import r1 from '../../assets/img/lateral x ray.png';
import r2 from '../../assets/img/panoramic final.png';

import r3 from "../../assets/img/upper scan.png"
import r4 from "../../assets/img/lower scan.png"


import back from "../../assets/icons/back.png"
import next from "../../assets/icons/next.png"
import { onAuthStateChanged } from 'firebase/auth'
import { useNavigate, useLocation } from 'react-router'
import { deleteDoc, doc } from 'firebase/firestore'
import { listAll } from 'firebase/storage'
import Prescription from '../../components/prescription/prescription';
import Valider from '../../components/valider/valider';
import Packs from '../packs/packs';

const AjouterPatient = () => {
    const location = useLocation();
    const patientToEdit = location.state?.patient;
    const initialStep = location.state?.currentStep || 0;

    const [age, setAge] = useState(patientToEdit?.age || null);
    const [ageError, setAgeError] = useState(false);
    const [user, setUser] = useState(null);
    const [selectedPatientType, setSelectedPatientType] = useState(patientToEdit?.category || null);
    const [patientId, setPatientId] = useState(patientToEdit?.id || null);
    
    const initialBirthDate = patientToEdit?.dateOfBirth ? {
        day: patientToEdit.dateOfBirth.split('-')[2],
        month: patientToEdit.dateOfBirth.split('-')[1],
        year: patientToEdit.dateOfBirth.split('-')[0]
    } : { day: '', month: '', year: '' };
    
    const [birthDate, setBirthDate] = useState(initialBirthDate);
    const [selectedConditions, setSelectedConditions] = useState(patientToEdit?.conditions || []);
    const [prescriptionData, setPrescriptionData] = useState(patientToEdit?.prescription || null);
    const [currentStep, setCurrentStep] = useState(initialStep);
    
    const [patientDetails, setPatientDetails] = useState({
        nom: patientToEdit?.name || '',
        prenom: patientToEdit?.surname || '',
        genre: patientToEdit?.gender || '',
        age: patientToEdit?.age || null,
        birthDate: initialBirthDate,
        category: patientToEdit?.category || null,
        conditions: patientToEdit?.conditions || []
    });

    const [images, setImages] = useState({
        image1: patientToEdit?.images?.img1 || null,
        image2: patientToEdit?.images?.img2 || null,
        image3: patientToEdit?.images?.img3 || null,
        image4: patientToEdit?.images?.img4 || null,
        image6: patientToEdit?.images?.img6 || null,
        image7: patientToEdit?.images?.img7 || null,
        image8: patientToEdit?.images?.img8 || null,
        image9: patientToEdit?.images?.img9 || null,
        image10: patientToEdit?.images?.img10 || null,
        image11: patientToEdit?.images?.img11 || null,
        image12: patientToEdit?.images?.img12 || null,
        image13: patientToEdit?.images?.img13 || null
    });

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const prescriptionRef = useRef();
    const conditions = [
        "Encombrement", "Espacement", "Proalvéolie", "Articulé inversé anterieur", 
        "Surplomb", "Articulé inversé postérieur", "Supraclusion", "Classe II division 1", 
        "Classe II division 2", "Classe III", "Arcade étroite", "Béance"
    ];

    const steps = [
        { icon: choisir, label: "Choisir un produit" },
        { icon: detail, label: "Détails du patient" },
        { icon: radio, label: "Photos/Radiographie" },
        { icon: scan, label: "Scans" },
        { icon: prescription, label: "Prescription" },
        { icon: review, label: "Vérifier et soumettre" }
    ];
     
    
        useEffect(() => {
            document.querySelectorAll(`.${styles.step}`).forEach((step, index) => {
                step.classList.remove(styles.active, styles.completed);
                if (index < currentStep) step.classList.add(styles.completed);
                if (index === currentStep) step.classList.add(styles.active);
            });
        }, [currentStep]);
    
        const [yearInputTimeout, setYearInputTimeout] = useState(null);

        useEffect(() => {
            // Clear previous timeout if it exists
            if (yearInputTimeout) {
                clearTimeout(yearInputTimeout);
            }

            // Set new timeout
            const timeoutId = setTimeout(() => {
                // Only calculate if year is a valid 4-digit number
                if (birthDate.year && birthDate.year.toString().length === 4) {
                    const today = new Date();
                    // Use current month and day if not yet specified
                    const month = birthDate.month || (today.getMonth() + 1);
                    const day = birthDate.day || today.getDate();
                    
                    const birth = new Date(birthDate.year, month - 1, day);
                    let calculatedAge = today.getFullYear() - birth.getFullYear();
                    
                    const monthDiff = today.getMonth() - (month - 1);
                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
                        calculatedAge--;
                    }
                    
                    setAge(calculatedAge);
                    
                    // Update patientDetails with the calculated age and birthDate
                    setPatientDetails(prevDetails => ({
                        ...prevDetails,
                        age: calculatedAge,
                        birthDate: { day, month, year: birthDate.year }
                    }));
                    
                    // Check age restrictions based on patient type if a type is selected
                    if (selectedPatientType) {
                        checkAgeRestrictions(calculatedAge);
                    }
                }
            }, 500);

            setYearInputTimeout(timeoutId);

            return () => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            };
        }, [birthDate.year, birthDate.month, birthDate.day, selectedPatientType]);
    
        const checkAgeRestrictions = (calculatedAge) => {
            if ((selectedPatientType === 'Adulte' && calculatedAge < 18) ||
                (selectedPatientType === 'Adolescent' && (calculatedAge < 12 || calculatedAge >= 18))) {
                setAgeError(true);
                setError(
                    selectedPatientType === 'Adulte' 
                        ? "L'âge doit être supérieur ou égal à 18 ans pour un patient adulte"
                        : "L'âge doit être entre 12 et 17 ans pour un patient adolescent"
                );
            } else {
                setAgeError(false);
                setError(null);
            }
        };

        const handleBack = () => setCurrentStep(currentStep - 1);
        const handleCardClick = (type) => {
            setSelectedPatientType(type);
            setPatientDetails(prev => ({...prev, category: type}));
            
            // If age is already calculated, check restrictions when patient type changes
            if (age !== null) {
                if ((type === 'Adulte' && age < 18) ||
                    (type === 'Adolescent' && (age < 12 || age >= 18))) {
                    setAgeError(true);
                    setError(
                        type === 'Adulte' 
                            ? "L'âge doit être supérieur ou égal à 18 ans pour un patient adulte"
                            : "L'âge doit être entre 12 et 17 ans pour un patient adolescent"
                    );
                } else {
                    setAgeError(false);
                    setError(null);
                }
            }
        };
        const handleConditionClick = (condition) => {
            setSelectedConditions((prev) => {
                const newConditions = prev.includes(condition) 
                    ? prev.filter((c) => c !== condition) 
                    : [...prev, condition];
                
                // Update patientDetails with the new conditions
                setPatientDetails(prevDetails => ({
                    ...prevDetails,
                    conditions: newConditions
                }));
                
                return newConditions;
            });
        };
      
    
        useEffect(() => {
            const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
                if (!currentUser) {
                    navigate('/');
                } else {
                    try {
                        // Try to get user role from medecins collection first
                        const medecinsQuery = collection(db, 'medecins');
                        const q = query(medecinsQuery, where("email", "==", currentUser.email));
                        const querySnapshot = await getDocs(q);
                        
                        if (!querySnapshot.empty) {
                            // Found in medecins collection
                            const medecinData = querySnapshot.docs[0].data();
                            
                            // Check for specialite field
                            const medecinRole = medecinData.role || 'dentiste';
                            const medecinSpecialite = medecinData.specialite || '';
                            
                            // If specialite contains "ortho", set role to orthodontiste
                            const effectiveRole = 
                                medecinSpecialite && medecinSpecialite.toLowerCase().includes('ortho') 
                                    ? 'orthodontiste' 
                                    : medecinRole;
                            
                            setUser({
                                ...currentUser,
                                role: effectiveRole,
                                specialite: medecinSpecialite,
                                medecinId: querySnapshot.docs[0].id,
                                userData: medecinData
                            });
                            
                            /*console.log("Medecin document found - ID:", querySnapshot.docs[0].id);
                            console.log("Role from medecins collection:", medecinRole);
                            console.log("Specialite from medecins:", medecinSpecialite);
                            console.log("Effective role being used:", effectiveRole);*/
                        } else {
                            // Fallback to users collection
                            const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
                            if (userDoc.exists()) {
                                const userData = userDoc.data();
                                setUser({
                                    ...currentUser,
                                    role: userData.role || 'dentiste',
                                    userData: userData
                                });
                                /*console.log("User role from users collection:", userData.role);*/
                            } else {
                                // No user document found, use basic user info
                                setUser(currentUser);
                                /*console.log("No user document found in either collection for:", currentUser.uid);*/
                            }
                        }
                    } catch (error) {
                        /*console.error("Error fetching user data:", error);*/
                        setUser(currentUser);
                    }
                }
            });
            return () => unsubscribe();
        }, []);
    
        const [prescriptionSection, setPrescriptionSection] = useState(null);
    
        const handleModify = (step, section) => {
            /*console.log(`Modifying step ${step}, section ${section}`);*/
            
            // Navigate to the specified step
            setCurrentStep(step);
            
            // If we're going to the prescription step, set the active section
            if (step === 4 && section) {
                // Use setTimeout to ensure the component is mounted before trying to access it
                setTimeout(() => {
                    if (prescriptionRef.current) {
                        prescriptionRef.current.setActiveSection(section);
                    }
                }, 100);
            }
        };

        const handleNext = async () => {
            try {
                setIsLoading(true);
                setError(null);

                // For step 0 (patient type selection)
                if (currentStep === 0) {
                    if (!patientDetails.category) {
                        throw new Error("Veuillez sélectionner un type de patient");
                    }

                    // Create patient document only at step 0
                    if (!patientId) {
                        const patientData = {
                            userId: user.uid,
                            status: 0,
                            archived: 0,
                            createdAt: serverTimestamp(),
                            category: patientDetails.category,
                            lastModified: serverTimestamp(),
                        };
                        if (selectedPack) {
                            patientData.pack = selectedPack;
                        }
                        const docRef = await addDoc(collection(db, 'patients'), patientData);
                        setPatientId(docRef.id);
                    } else {
                        // Update existing patient with pack if selected
                        const updateData = {
                            lastModified: serverTimestamp(),
                        };
                        if (selectedPack) {
                            updateData.pack = selectedPack;
                        }
                        const patientRef = doc(db, 'patients', patientId);
                        await updateDoc(patientRef, updateData);
                    }
                }

                // For step 1 (patient details)
                if (currentStep === 1) {
                    if (!patientDetails.nom || !patientDetails.prenom || !patientDetails.genre) {
                        throw new Error("Veuillez remplir tous les champs obligatoires");
                    }
                    if (!patientDetails.birthDate?.day || !patientDetails.birthDate?.month || !patientDetails.birthDate?.year) {
                        throw new Error("Veuillez entrer une date de naissance complète");
                    }
                    if (ageError) {
                        throw new Error("L'âge ne correspond pas au type de patient sélectionné");
                    }

                    // Format birthdate
                    const formattedBirthDate = `${patientDetails.birthDate.year}-${String(patientDetails.birthDate.month).padStart(2, '0')}-${String(patientDetails.birthDate.day).padStart(2, '0')}`;

                    // Update patient details
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, {
                        surname: patientDetails.nom,
                        name: patientDetails.prenom,
                        gender: patientDetails.genre,
                        dateOfBirth: formattedBirthDate,
                        age: patientDetails.age,
                        conditions: patientDetails.conditions || [],
                        lastModified: serverTimestamp(),
                    });
                }

                // Check required photos in step 3
                if (currentStep === 2) {
                    if (!patientId) {
                        throw new Error("Patient ID not found. Please start from step 1.");
                    }
                    const requiredImages = ['image1', 'image2', 'image3', 'image4', 'image6', 'image8', 'image9', 'image10'];
                    const missingImages = requiredImages.filter(img => !images[img]);
                    
                    if (missingImages.length > 0) {
                        throw new Error("Veuillez télécharger toutes les photos requises avant de continuer");
                    }
                    
                    // Update step in Firestore
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, {
                        lastModified: serverTimestamp(),
                    });
                }

                // Check required scans in step 4
                if (currentStep === 3) {
                    if (!patientId) {
                        throw new Error("Patient ID not found. Please start from step 1.");
                    }
                    if (!images.image12 || !images.image13) {
                        throw new Error("Veuillez télécharger les deux scans (Maxillaire et Mandibule) avant de continuer");
                    }
                    
                    // Update step in Firestore
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, {
                        lastModified: serverTimestamp(),
                    });
                }

                // When moving from step 4 (prescription) to step 5 (validation)
                if (currentStep === 4) {
                    if (!patientId) {
                        throw new Error("Patient ID not found. Please start from step 1.");
                    }

                    // Get current prescription data
                    const currentPrescriptionData = prescriptionRef.current ? prescriptionRef.current.getPrescriptionData() : null;
                    
                    if (!currentPrescriptionData) {
                        throw new Error("Erreur lors de la récupération des données de prescription");
                    }

                    // Update prescription data in state
                    setPrescriptionData(currentPrescriptionData);
                    
                    // Update Firestore with prescription data
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, {
                        prescription: currentPrescriptionData,
                        lastModified: serverTimestamp(),
                    });

                    /*console.log("Prescription data saved:", currentPrescriptionData);*/
                }
                
                // When finalizing at step 5
                if (currentStep === 5 && patientId) {
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, {
                        lastModified: serverTimestamp(),
                        status: 1, // Mark as completed
                        prescriptionSubmittedAt: serverTimestamp()
                    });
                }
                
                setCurrentStep(currentStep + 1);
            } catch (error) {
                console.error("Error in handleNext:", error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        const MAX_FILE_SIZE = 15 * 1024 * 1024; // 5MB in bytes

        const [uploadError, setUploadError] = useState('');

        const [imageFiles, setImageFiles] = useState({});

        const handleUpload = async (e, imageKey) => {
            const file = e.target.files[0];
            
            if (file) {
                try {
                    setUploadError('');
                    setIsLoading(true);

                    // Check file size only for photos (not for scans)
                    const isScanFile = imageKey === 'image12' || imageKey === 'image13';
                    if (!isScanFile && file.size > MAX_FILE_SIZE) {
                        setUploadError(`L'image "${file.name}" est trop volumineuse. La taille maximale autorisée est de 15 Mo.`);
                        e.target.value = '';
                        return;
                    }

                    // Validate file extension for scan files
                    if (isScanFile) {
                        const fileExtension = file.name.split('.').pop().toLowerCase();
                        const allowedExtensions = ['stl', 'ply', 'obj'];
                        
                        if (!allowedExtensions.includes(fileExtension)) {
                            setUploadError(`Le fichier "${file.name}" n'est pas autorisé. Seuls les fichiers .stl, .ply et .obj sont acceptés pour les scans.`);
                            e.target.value = '';
                            return;
                        }
                    }

                    const firebaseImageKey = `img${imageKey.replace('image', '')}`;
                    
                    // Extract file extension from the file name
                    const fileExtension = file.name.split('.').pop().toLowerCase();

                    // Add current date and time to the filename (YYYY-MM-DD_HH-MM-SS)
                    const now = new Date();
                    const pad = n => n.toString().padStart(2, '0');
                    const dateStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
                    const filenameWithDate = `${firebaseImageKey}_${dateStr}.${fileExtension}`;

                    // Handle all images (including scans)
                    if (patientId) {
                        // Use the new filename with date
                        const storageRef = ref(storage, `images/${patientId}/${filenameWithDate}`);
                        await uploadBytes(storageRef, file);
                        const downloadURL = await getDownloadURL(storageRef);
                        
                        // Update Firestore
                        const patientRef = doc(db, "patients", patientId);
                        await updateDoc(patientRef, {
                            [`images.${firebaseImageKey}`]: downloadURL,
                            lastModified: serverTimestamp()
                        });

                        // Update local state
                        setImages(prev => ({
                            ...prev,
                            [imageKey]: downloadURL
                        }));
                    }

                    // Store file reference
                    setImageFiles(prev => ({
                        ...prev,
                        [firebaseImageKey]: file
                    }));

                } catch (error) {
                    /*console.error('Error uploading file:', error);*/
                    setUploadError('Une erreur est survenue lors du téléchargement. Veuillez réessayer.');
                    e.target.value = '';
                } finally {
                    setIsLoading(false);
                }
            }
        };

        const updateBirthDate = (field, value) => {
            setBirthDate(prev => {
                const newBirthDate = { ...prev, [field]: value };
                
                // Update patientDetails with the new birthDate
                setPatientDetails(prevDetails => ({
                    ...prevDetails,
                    birthDate: newBirthDate
                }));
                
                return newBirthDate;
            });
        };

        const handleSave = async (shouldValidate = false) => {
            const confirmSave = window.confirm("Voulez-vous enregistrer les modifications?");
            if (!confirmSave) return;

            try {
                setIsLoading(true);
                setError(null);

                // Get current prescription data if available
                const currentPrescriptionData = currentStep >= 4 && prescriptionRef.current 
                    ? prescriptionRef.current.getPrescriptionData() 
                    : prescriptionData;

                // Format birthdate if available
                const formattedDateOfBirth = patientDetails.birthDate?.year && patientDetails.birthDate?.month && patientDetails.birthDate?.day 
                    ? `${patientDetails.birthDate.year}-${String(patientDetails.birthDate.month).padStart(2, '0')}-${String(patientDetails.birthDate.day).padStart(2, '0')}` 
                    : null;

                // Build patient data with only available fields
                const patientData = {
                    lastModified: serverTimestamp(),
                    status: shouldValidate ? 1 : 0,
                    archived: 0,
                };
                if (patientDetails.category) patientData.category = patientDetails.category;
                if (selectedPack) patientData.pack = selectedPack;
                if (patientDetails.nom) patientData.surname = patientDetails.nom;
                if (patientDetails.prenom) patientData.name = patientDetails.prenom;
                if (patientDetails.genre) patientData.gender = patientDetails.genre;
                if (formattedDateOfBirth) patientData.dateOfBirth = formattedDateOfBirth;
                if (patientDetails.age) patientData.age = patientDetails.age;
                if (patientDetails.conditions && patientDetails.conditions.length > 0) patientData.conditions = patientDetails.conditions;
                if (user?.uid) patientData.userId = user.uid;

                // Add images and prescription if available
                const imageData = {};
                const scanData = {};
                Object.entries(images).forEach(([key, value]) => {
                    if (value) {
                        if (key === 'image12' || key === 'image13') {
                            const scanKey = `img${key.replace('image', '')}`;
                            scanData[scanKey] = value;
                        } else {
                            const imgKey = `img${key.replace('image', '')}`;
                            imageData[imgKey] = value;
                        }
                    }
                });
                if (Object.keys(imageData).length > 0 || Object.keys(scanData).length > 0) {
                    patientData.images = { ...imageData, ...scanData };
                }
                if (currentPrescriptionData) patientData.prescription = currentPrescriptionData;

                // Save or update
                if (patientId) {
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, patientData);
                } else {
                    patientData.createdAt = serverTimestamp();
                    const docRef = await addDoc(collection(db, 'patients'), patientData);
                    setPatientId(docRef.id);
                }

                navigate('/profile');
            } catch (error) {
                setError("Erreur lors de l'enregistrement. Essayez encore.");
            } finally {
                setIsLoading(false);
            }
        };

        const handleCancel = async () => {
            const confirmCancel = window.confirm("Êtes-vous sûr de vouloir supprimer ce patient? Cette action est irréversible.");
            if (confirmCancel) {
                try {
                    setIsLoading(true);
                    
                    // Delete all images from storage
                    if (patientId) {
                        const storageRef = ref(storage, `images/${patientId}`);
                        try {
                            const filesList = await listAll(storageRef);
                            const deletePromises = filesList.items.map(fileRef => deleteObject(fileRef));
                            await Promise.all(deletePromises);
                        } catch (storageError) {
                            /*console.error("Error deleting images:", storageError);*/
                        }

                        // Delete the patient document
                        const patientRef = doc(db, 'patients', patientId);
                        await deleteDoc(patientRef);
                    }

                    navigate('/profile');
                } catch (error) {
                    /*console.error("Error canceling:", error);*/
                    setError("Une erreur s'est produite lors de la suppression du patient");
                } finally {
                    setIsLoading(false);
                }
            }
        };

        const navigate = useNavigate()

        useEffect(() => {
            let unsubscribe;
            
            if (patientId) {
                const patientRef = doc(db, 'patients', patientId);
                unsubscribe = onSnapshot(
                    patientRef, 
                    { includeMetadataChanges: false },
                    (snapshot) => {
                        if (!snapshot.exists()) return;
                        
                        const data = snapshot.data();
                        if (data?.images) {
                            try {
                                const newImages = {};
                                Object.entries(data.images).forEach(([key, value]) => {
                                    const localKey = `image${key.replace('img', '')}`;
                                    newImages[localKey] = value;
                                });
                                
                                setImages(prev => {
                                    const hasChanges = JSON.stringify(prev) !== JSON.stringify(newImages);
                                    return hasChanges ? newImages : prev;
                                });
                            } catch (error) {
                                /*console.error("Error processing image data:", error);*/
                            }
                        }
                        
                        // Update pack if it exists in the data
                        if (data?.pack) {
                            setSelectedPack(data.pack);
                            setPatientDetails(prev => ({...prev, pack: data.pack}));
                        }
                    }
                );
            }

            return () => {
                if (unsubscribe) {
                    unsubscribe();
                }
            };
        }, [patientId]);

        const getImagePlaceholder = (imageName) => {
            // For the first three images, use gender-specific placeholders
            if (['image1', 'image2', 'image3'].includes(imageName)) {
                if (patientDetails.genre === 'Female') {
                    switch(imageName) {
                        case 'image1': return p1;
                        case 'image2': return p2;
                        case 'image3': return p3;
                        default: return p1;
                    }
                } else {
                    switch(imageName) {
                        case 'image1': return h1;
                        case 'image2': return h2;
                        case 'image3': return h3;
                        default: return h1;
                    }
                }
            }
            // For other images, use default placeholders
            switch(imageName) {
                case 'image4': return p4;
                case 'image6': return p5;
                case 'image7': return p6;
                case 'image8': return p7;
                case 'image9': return p8;
                case 'image10': return r2;
                case 'image11': return r1;
                case 'image12': return r3;
                case 'image13': return r4;
                default: return p1;
            }
        };

        useEffect(() => {
           /* console.log("Current Step:", currentStep);
            console.log("Prescription Data:", prescriptionData);*/
        }, [currentStep, prescriptionData]);

        // Initialize selectedPack from patientToEdit if it exists
        const [selectedPack, setSelectedPack] = useState(patientToEdit?.pack || null);

        // Add handlePackSelect function
        const handlePackSelect = async (pack) => {
            setSelectedPack(pack);
            setPatientDetails(prev => ({...prev, pack}));
            
            // Update pack in Firebase if patient exists
            if (patientId) {
                try {
                    const patientRef = doc(db, 'patients', patientId);
                    await updateDoc(patientRef, {
                        pack: pack,
                        lastModified: serverTimestamp()
                    });
                } catch (error) {
                    /*console.error("Error updating pack:", error);*/
                    setError("Une erreur est survenue lors de la mise à jour du pack");
                }
            }
        };

        return (
            <>
            <HeaderBlack/>
            <main>
                <StatusCard/>
                <div className={styles.header}>
                    <h2>Ajouter patient</h2>
                    <button className={styles.closeBtn} onClick={() => navigate('/profile')}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
            
                <div className={styles.container}>
                    <nav className={styles.sidebar}>
                        {steps.map((step, index) => (
                            <React.Fragment key={index}>
                                <div className={`${styles.step} ${index === currentStep ? styles.active : ''}`}>
                                    <div className={styles.stepIcon}><img src={step.icon} alt={step.label} /></div>
                                    <span>{step.label}</span>
                                </div>
                                {index < 5 && (
                                    <div className={styles.line}>
                                        <img src={line} alt="line"/>
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </nav>

                <main className={styles.content}>
                    {/* Step 1: Choose Product */}
                    {currentStep === 0 && (
                        <div className={`${styles.formStep} ${styles.active}`}>
                            <div className={styles.sectionHeader}>
                                <img src={choisir3} alt="Choisir un produit" />
                                <h2>Choisir un produit</h2>
                            </div>
                            <div className={styles.scrollableContent}>
                            <h3>Select patient type : <span className={styles.required}>*</span></h3>
                            <div className={styles.cardGrid}>
                                {[{ label: 'Adulte', img: adult, type: 'Adulte' }, 
                                   { label: 'Adolescent', img: adol, type: 'Adolescent' }].map(({ label, img, type }) => (
                                    <div 
                                        key={label} 
                                        className={`${styles.card} ${selectedPatientType === type ? styles.selected : ''}`} 
                                    >
                                        <div className={styles.checkIcon}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </div>
                                        <h4>{label}</h4>
                                        <img src={img} alt={label} />
                                        <button 
                                            className={styles.selectBtn}
                                            onClick={() => handleCardClick(type)}
                                        >
                                            Sélectionner
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <h3>Select pack :</h3>
                            <div className={styles.scrollablePacks}>
                                <Packs onSelectPack={handlePackSelect} selectedPack={selectedPack} user={user} />
                            </div>
                            </div>
                        </div>
                    )}
                
                    {/* Step 2: Patient Details */}
                    {currentStep === 1 && (
                        <div className={`${styles.formStep} ${styles.active}`}>
                            <div className={styles.sectionHeader}>
                                <img src={detail3} alt="details" />
                                <h2>Détails du patient</h2>
                            </div>
                            <div className={styles.formGroup}>
                                <label>Nom: <span className={styles.required}>*</span></label>
                                <input 
                                    className={styles.inputDetails} 
                                    type="text" 
                                    value={patientDetails.nom}
                                    onChange={(e) => setPatientDetails({...patientDetails, nom: e.target.value})} 
                                    required 
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Prénom: <span className={styles.required}>*</span></label>
                                <input 
                                    className={styles.inputDetails} 
                                    type="text" 
                                    value={patientDetails.prenom}
                                    onChange={(e) => setPatientDetails({...patientDetails, prenom: e.target.value})} 
                                    required 
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Date de naissance: <span className={styles.required}>*</span></label>
                                <div className={styles.dateInputs}>
                                    <input 
                                        className={styles.inputDetails} 
                                        type="text" 
                                        placeholder="JJ" 
                                        maxLength="2" 
                                        value={birthDate.day}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Only allow numbers, ensure day is between 1-31, and prevent "00"
                                            if ((!value || /^\d+$/.test(value)) && 
                                                (!value || (parseInt(value) <= 31 && (value !== "00")))) {
                                                updateBirthDate('day', value);
                                            }
                                        }}
                                        required 
                                    />
                                    <input 
                                        className={styles.inputDetails} 
                                        type="text" 
                                        placeholder="MM" 
                                        maxLength="2" 
                                        value={birthDate.month}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Only allow numbers, ensure month is between 1-12, and prevent "00"
                                            if ((!value || /^\d+$/.test(value)) && 
                                                (!value || (parseInt(value) <= 12 && (value !== "00")))) {
                                                updateBirthDate('month', value);
                                            }
                                        }}
                                        required 
                                    />
                                    <input 
                                        className={styles.inputDetails} 
                                        type="text" 
                                        placeholder="AAAA" 
                                        maxLength="4" 
                                        value={birthDate.year}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Only allow numbers and prevent "0000" for year
                                            if ((!value || /^\d+$/.test(value)) && 
                                                (!value || value !== "0000")) {
                                                updateBirthDate('year', value);
                                            }
                                        }} 
                                        required 
                                    />
                                </div>
                            </div>
                            <div className={styles.formGroup}>
                            <p>Âge: {age ? `${age} ans` : ''}</p>
                            {ageError && <p className={styles.errorText}>{error}</p>}
                            </div>
                            <div className={styles.formGroup}>
                                <label>Genre: <span className={styles.required}>*</span></label>
                                <div className={styles.radioGroup}>
                                    <div className={styles.radioOption}>
                                    <input 
                                        type="radio" 
                                        name="gender" 
                                        id="male" 
                                        value="Male"  
                                        checked={patientDetails.genre === "Male"}
                                        onChange={(e) => setPatientDetails({ ...patientDetails, genre: e.target.value })}
                                    />
                                    <label htmlFor="male">Male</label>
                                    </div>
                                    <div className={styles.radioOption}>
                                    <input 
                                        type="radio" 
                                        name="gender" 
                                        id="female" 
                                        value="Female"
                                        checked={patientDetails.genre === "Female"}
                                        onChange={(e) => setPatientDetails({ ...patientDetails, genre: e.target.value })}
                                    />
                                    <label htmlFor="female">Female</label>
                                    </div>
                                    <div className={styles.radioOption}>
                                    <input 
                                        type="radio" 
                                        name="gender" 
                                        id="other" 
                                        value="Autre"
                                        checked={patientDetails.genre === "Autre"}
                                        onChange={(e) => setPatientDetails({ ...patientDetails, genre: e.target.value })}
                                    />
                                    <label htmlFor="other">Autre</label>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                            <label>Conditions Clinique: </label>
                            <div className={styles.conditionGrid}>
                            {conditions.map((condition, index) => (
                                    <div 
                                        key={index} 
                                        className={`${styles.conditionTag} ${selectedConditions.includes(condition) ? styles.selected : ''}`} 
                                        onClick={() => handleConditionClick(condition)}
                                    >
                                        {condition}
                                    </div>
                                ))}
                            </div>
                        </div>
                        </div>
            )}
            {/* step3 */}
                {currentStep == 2 && (
                    <div className={`${styles.formStep} ${styles.active}`}>
                        <div className={styles.sectionHeader}>
                            <img src={photoRadiographie} alt="Photos / Radiographie" />
                            <h2>Photos / Radiographies</h2>
                        </div>
                        {isLoading && (
                        <div className={styles.loadingSpinner}>
                            Loading...
                        </div>
                    )}
                        <div className={styles.scrollableContent}>
                            <div className={styles.photoSection}>
                                <h3>Photos extra et intraorales <span className={styles.required}>*</span></h3>
                                <p className={styles.uploadInstruction}>
                                    Selectionner (depuis votre ordinateur) / utiliser l'application Diamond Clinic
                                    <span className={styles.fileSizeLimit}> - Taille max de l'image: 15Mo</span>
                                </p>

                                <div className={styles.photoGrid}>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image1 || getImagePlaceholder('image1')} alt="Profile"  />
                                        <label className={styles.uploadBtn} htmlFor="image1-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image1-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image1')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Portrait de profil au repos <span className={styles.required}>*</span></span>
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image2 || getImagePlaceholder('image2')} alt="Frontal" />
                                        <label className={styles.uploadBtn} htmlFor="image2-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image2-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image2')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Portrait de face au repos  <span className={styles.required}>*</span></span>
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image3 || getImagePlaceholder('image3')} alt="Smiling" />
                                        <label className={styles.uploadBtn} htmlFor="image3-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image3-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image3')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Portrait de face en sourire  <span className={styles.required}>*</span></span>
                                    </div>
                                </div>

                                <div className={styles.photoGrid}>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image4 || p4} alt="Upper Arch" />
                                        <label className={styles.uploadBtn} htmlFor="image4-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image4-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image4')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Occlusale supérieure  <span className={styles.required}>*</span></span>
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <img src={icone} alt="Frontal outline" />
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image6 || p5} alt="Lower Arch" />
                                        <label className={styles.uploadBtn} htmlFor="image6-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image6-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image6')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Occlusale inférieure <span className={styles.required}>*</span></span>
                                    </div>
                                </div>

                                <div className={styles.photoGrid}>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image7 || p6} alt="Upper jaw" />
                                        <label className={styles.uploadBtn} htmlFor="image7-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image7-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image7')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Intra-orale latérale droite <span className={styles.required}>*</span></span>
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image8 || p7} alt="Front View" />
                                        <label className={styles.uploadBtn} htmlFor="image8-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image8-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image8')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Intra-orale de face <span className={styles.required}>*</span></span>
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <img src={images.image9 || p8} alt="Lower jaw" />
                                        <label className={styles.uploadBtn} htmlFor="image9-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image9-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image9')}
                                            className={styles.hiddenInput}
                                        />
                                        <span className={styles.photoLabel}>Intra-orale latérale gauche  <span className={styles.required}>*</span></span>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.radioSection}>
                                <div className={styles.radioGrid}>
                                    <div className={styles.photoUploadBox}>
                                        <h4>Panoramique <span className={styles.required}>*</span></h4>
                                        <img src={images.image10 || r2} alt="Panoramic X-ray" />
                                        <label className={styles.uploadBtn} htmlFor="image10-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image10-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image10')}
                                            className={styles.hiddenInput}
                                        />
                                    </div>
                                    <div className={styles.photoUploadBox}>
                                        <h4>Radiographie de profil</h4>
                                        <img src={images.image11 || r1} alt="Profile X-ray" />
                                        <label className={styles.uploadBtn} htmlFor="image11-input">
                                            Select photo to upload +
                                        </label>
                                        <input
                                            id="image11-input"
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'image11')}
                                            className={styles.hiddenInput}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                    {/* step4 */}
                {currentStep == 3 && (
                    <div className={`${styles.formStep} ${styles.active}`}>
                        <div className={styles.sectionHeader}>
                            <img src={scan3} alt="Scans" />
                            <h2>Scans</h2>
                        </div>
                       
                        <section className={styles.photoSection}>
                            <p className={styles.uploadInstruction}>
                                Selectionner (depuis votre ordinateur) / utiliser l'application Diamond Clinic
                            </p>
                            {isLoading && (
                        <div className={styles.loadingSpinner}>
                            Loading...
                        </div>
                    )}
                            <div className={styles.photoGrid}>
                                <div className={styles.photoUploadBox}>
                                    <span className={styles.photoLabel}>Maxillaire <span className={styles.required}>*</span></span>
                                    <div className={styles.scanUploadContainer}>
                                        <img src={r3} alt="upper scan" className={styles.img1}/>
                                        {images?.image12 && (
                                            <div className={styles.uploadOverlay}>
                                                <div className={styles.checkIconOverlay}>
                                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <label className={styles.uploadBtn} htmlFor="image12-input">
                                        {images?.image12 ? 'Changer le fichier +' : 'Select file to upload +'}
                                    </label>
                                    <input
                                        id="image12-input"
                                        type="file"
                                        accept=".stl,.ply,.obj"
                                        onChange={(e) => handleUpload(e, 'image12')}
                                        className={styles.hiddenInput}
                                    />
                                </div>
                                <div className={styles.photoUploadBox}>
                                    <span className={styles.photoLabel}>Mandibule <span className={styles.required}>*</span></span>
                                    <div className={styles.scanUploadContainer}>
                                        <img src={r4} alt="lower scan" className={styles.img1} />
                                        {images?.image13 && (
                                            <div className={styles.uploadOverlay}>
                                                <div className={styles.checkIconOverlay}>
                                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <label className={styles.uploadBtn} htmlFor="image13-input">
                                        {images?.image13 ? 'Changer le fichier +' : 'Select file to upload +'}
                                    </label>
                                    <input
                                        id="image13-input"
                                        type="file"
                                        accept=".stl,.ply,.obj"
                                        onChange={(e) => handleUpload(e, 'image13')}
                                        className={styles.hiddenInput}
                                    />
                                </div>
                            </div>
                        </section>
                    </div>
                )}
                <div className={`${styles.formStep} ${currentStep === 4 ? styles.active : ''}`}>
                    <Prescription
                        ref={prescriptionRef}
                        prescriptionData={prescriptionData}
                        patientDetails={patientDetails}
                    />
                </div>

                <div className={`${styles.formStep} ${currentStep === 5 ? styles.active : ''}`}>
                    <div className={styles.validationStep}>
                        {currentStep === 5 && (
                            <>
                               {/* {console.log("Current Step:", currentStep)}
                                {console.log("Prescription Data:", prescriptionData)}
                                {console.log("Patient Details:", patientDetails)}
                                {console.log("User Role being passed to Valider:", user?.role)}
                                {console.log("Full User Object:", user)}*/}
                                <Valider 
                                    prescriptionData={prescriptionData}
                                    patientDetails={patientDetails}
                                    onModify={handleModify}
                                    userRole={user?.role || 'dentiste'}
                                />
                            </>
                        )}
                    </div>
                </div>
                    <div className={styles.actionButtons}>
                    {currentStep > 0 && (
                                    <button className={`${styles.btn} ${styles.btnBack}`} onClick={handleBack}>
                                        <img className={styles.btnIcon} src={back} alt="back" /> Retour
                                    </button>
                                )}

                    <button className={`${styles.btn} ${styles.btnCancel}`} onClick={handleCancel}>
                        <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Annuler le cas 
                    </button>

                    <button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => handleSave(false)}>
                        Enregistrer et fermer
                    </button>
                    {currentStep == 5 &&
                    (<button className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => handleSave(true)}>
                        valider
                    </button>)}

                    {currentStep < 5 && (<button className={`${styles.btn} ${styles.btnNext}`} onClick={handleNext}>
                                    Suivant <img className={styles.btnIcon} src={next} alt="next" />
                                </button>)}
                    </div>

                    {error && (
                        <div className={styles.errorMessage}>
                            {error}
                        </div>
                    )}
                  
                    
                    {uploadError && (
                        <div className={styles.errorMessage}>
                            {uploadError}
                        </div>
                    )}
                    
                </main>
            </div>
        </main>
        </>
      )
}

export default AjouterPatient